import script from "./VideoEditReplace.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoEditReplace.vue?vue&type=script&setup=true&lang=js"

import "./VideoEditReplace.vue?vue&type=style&index=0&id=31a7f22d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a7f22d"]])

export default __exports__